import { Component } from "components/components/Component";
import { ConfirmationDialog } from "components/confirmationDialog/confirmationDialog";
import { fireDataChangedCleared } from "components/form/dataChangedEventDetail";
import { I18nMessage } from "components/i18n/I18nMessage";
import $ from "jquery";

export class CancelConfirmation {
    private component: Component;

    private  def = {
        confirmationMessages: [new I18nMessage("dialog.confirm-discard")],
        confirmationAccept: new I18nMessage("dialog.confirm-accept"),
    };

    public confirm(component: Component) {
        this.component = component;
        const dialog = new ConfirmationDialog({...this.def, acceptCallback: this.acceptCallback});
        dialog.open();
    }

    public confirmRoute(acceptCallback) {
        const dialog = new ConfirmationDialog({...this.def, acceptCallback});
        dialog.open();
    }

    public acceptCallback = () => {
        fireDataChangedCleared(this.component.definition.id, this.component["view"]);
        $(this.component["view"]).parent()[0].dispatchEvent(new CustomEvent("pageUnstackRequested", {bubbles: true}));
    }
}
